module.exports = __webpack_public_path__ + "distribution/img/position-right.83872f74.png";